import React from 'react';
import { Avatar as MUIAvatar, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AvatarProps {
  title: string;
  src?: any;
  className?: string;
}

export function Avatar({ title, src = '', className }: AvatarProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <MUIAvatar
      sx={{ background: theme.palette.secondary.main }}
      aria-label={t('accessibility.USER_AVATAR')}
      src={src}
      className={className}
    >
      <Typography variant="subtitle1" color="black">
        {title}
      </Typography>
    </MUIAvatar>
  );
}
